<template>
  <div class="w-full h-screen bg-cover bg-landscape bg-light-green">
    <div
      class="container flex items-center justify-center flex-1 h-full mx-auto"
    >
      <div class="max-w-sm m-auto bg-white rounded shadow-xl">
        <header class="bg-app-green text-white text-3xl p-10 text-center">
          {{ title }}
        </header>

        <div class="p-10">
          <BaseAlertContainer
            :notifications="notifications"
            @close="closeNotification"
            v-if="notifications.length > 0"
          />

          <div class="relative mb-4">
            <BaseRequiredInput
              :autofocus="true"
              autocomplete="username"
              label="Username"
              :isInvalid="validationService.has('username')"
              :message="validationService.get('username')"
              v-model="form.username"
              @focus="validationService.clear()"
            />
          </div>
          <div class="relative mb-4">
            <BaseRequiredInputGroup
              autocomplete="current-password"
              :type="passwordType"
              label="Password"
              :isInvalid="validationService.has('password')"
              :message="validationService.get('password')"
              v-model="form.password"
              @focus="validationService.clear()"
              @icon-clicked="togglePassword"
            >
              <BaseEyeIcon
                class="h-3 w-3 cursor-pointer"
                v-if="passwordType === 'text'"
              />
              <BaseEyeCloseIcon
                class="h-3 w-3 cursor-pointer"
                v-if="passwordType === 'password'"
              />
            </BaseRequiredInputGroup>
          </div>

          <BaseButton
            name="orange"
            type="button"
            :disabled="loading"
            class="bg-orange"
            :class="{ disabled: loading }"
            @click="submit"
          >
            <template v-slot:icon>
              <BaseLoader class="mr-2" v-if="loading" />
            </template>
            Sign In
          </BaseButton>

          <div class="text-center mt-4">
            <div>
              <router-link
                :to="{ name: 'SendResetPasswordLink' }"
                class="text-orange hover:underline mt-2"
              >
                Forgot Password?
              </router-link>
            </div>
            <div>
              <router-link
                :to="{ name: 'SignUp' }"
                class="text-orange hover:underline mt-2"
              >
                Sign Up
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ValidationService from "@/services/ValidationService.js"

import { errorMixin } from "@/mixins/error.js"
import { passwordInputMixin } from "@/mixins/form.js"
import { notificationMixin } from "@/mixins/notification.js"

export default {
  mixins: [errorMixin, passwordInputMixin, notificationMixin],
  data() {
    return {
      loading: false,

      validationService: new ValidationService({
        username: null,
        password: null,
      }),

      title: process.env.VUE_APP_TITLE,

      form: {
        username: "",
        password: "",
      },
    }
  },
  methods: {
    submit() {
      this.clearNotifications()
      this.validationService.clear()

      if (this.isValid()) {
        this.loading = true

        this.$store
          .dispatch("user/login", this.form)
          .then((response) => {
            let family = response.family

            if (family.isLimbo) {
              this.$router.replace({ name: "LimboSteps" })
            } else {
              this.$router.replace({ name: "Dashboard" })
            }
          })
          .catch((error) => {
            this.handleError(error)
          })
          .finally(() => {
            this.loading = false
          })
      }
    },
    isValid() {
      if (this.form.username === "") {
        this.validationService.set("username", "Username cannot be blank")
      }

      if (this.form.password === "") {
        this.validationService.set("password", "Password cannot be blank")
      }

      return this.validationService.hasNoErrors()
    },
  },
}
</script>

<style lang="scss" scoped></style>
